import React from "react";
import Typed from "typed.js";
import UseData from "../Hooks/UseData";

function TypedComponent() {
  const { typedStrings } = UseData();
  const el = React.useRef(null);

  React.useEffect(
    () => {
      const typed = new Typed(el.current, {
        strings: typedStrings,
        loop: true,
        typeSpeed: 100,
        backSpeed: 50,
        backDelay: 2000,
      });

      return () => {
        typed.destroy();
      };
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  return <span className="font-mono text-xl pb-10" ref={el} />;
}

export default TypedComponent;
